import React from 'react';
import { defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { NAVIGATED_TO_LOVED_PATTERNS } from '../../actions/actionTypes';

import { addToFavorites, removeFromFavorites } from '../../actions/favorites';
import { goToPattern } from '../../actions/navigation';
import { showSnack } from '../../actions/uiActions';
import { getMessage } from '../../reducers/i18n';
import { getPatternDesigner, getPatterns } from '../../reducers/patterns';
import { getActiveSewpatId } from '../../reducers/sewpats';

import PatternGalleryBarFull from './PatternGalleryBarFull';
import PatternGalleryBarSmall from './PatternGalleryBarSmall';

const PatternGalleryAppBar = ({ type, ...props }) => {
    if (type === 'small') {
        return (
            <PatternGalleryBarSmall
                {...props}
            />
        );
    }
    return (
        <PatternGalleryBarFull
            {...props}
        />
    );
};

const mapDispatchToProps = dispatch => (
    {
        removeFromFavorites: (patternid, sewpatId, query) => dispatch(
            removeFromFavorites(patternid, sewpatId, query)),
        addToFavorites: (patternid, sewpatId, query) => dispatch(
            addToFavorites(patternid, sewpatId, query)),
        goToPattern: (patternid, sewpatId, query) => dispatch(
            goToPattern(patternid, sewpatId, query)),
        showAddedToFavorites: id => dispatch(
            showSnack(id, 'SNACK_PATTERN_ADDED_TO_FAVORITES', null, 2000,
                null,
            )),
    }
);

const makeMapStateToProps = (initialState, initialOwnProps) => {
    const remove = initialOwnProps.favoritesMode === false
        ? false
        : initialState.location.type === NAVIGATED_TO_LOVED_PATTERNS;
    const sewpatId = getActiveSewpatId(initialState);
    const mapStateToProps = (state, ownProps) => {
        const { patternid, query, type } = ownProps;
        const iconMore = getMessage(initialState, 'ICON_LABEL_MORE');
        const labelAddToFavorites = getMessage(initialState, 'ICON_LABEL_ADDTOFAVORITES');
        const labelRemoveFromFavorites = getMessage(initialState, 'ICON_LABEL_REMOVE_FROM_FAVORITES');
        const labelColoring = getMessage(initialState, 'ICON_LABEL_COLORING');
        const labelAddToCart = getMessage(initialState, 'ICON_LABEL_ADD_TO_CART');
        const patterns = getPatterns(state);
        const designer = getPatternDesigner(state, patternid);
        const imgSrc = ownProps.imgSrc;
        return {
            type,
            pattern: patterns[patternid],
            removeFavorites: remove,
            query,
            imgSrc,
            designerName: designer.name,
            sewpatId,
            iconMore,
            labelAddToCart,
            labelAddToFavorites,
            labelRemoveFromFavorites,
            labelColoring,
        };
    };
    return mapStateToProps;
};

export default connect(makeMapStateToProps, mapDispatchToProps)(
    PatternGalleryAppBar);

defineMessages({
    labelMore: {
        id: 'ICON_LABEL_MORE',
        description: 'Label text for more menu icon',
        defaultMessage: 'Mehr',
    },
    snackFavorite: {
        id: 'SNACK_PATTERN_ADDED_TO_FAVORITES',
        description: 'Message to show after a user added a pattern to favorites',
        defaultMessage: 'Motiv in Merkliste gespeichert.',
    },
    labelShare: {
        id: 'ICON_LABEL_SHARE',
        description: 'Label text for share icon',
        defaultMessage: 'Teilen',
    },
    labelAddToFavorites: {
        id: 'ICON_LABEL_ADDTOFAVORITES',
        description: 'Label text for addToFavorites icon',
        defaultMessage: 'Merken',
    },
    labelRemoveFromFavorites: {
        id: 'ICON_LABEL_REMOVE_FROM_FAVORITES',
        description: 'Label text for remove from favorites icon',
        defaultMessage: 'Entfernen',
    },
    labelColoring: {
        id: 'ICON_LABEL_COLORING',
        description: 'Label text for coloring icon',
        defaultMessage: 'Einfärben',
    },
    labelAddToCart: {
        id: 'ICON_LABEL_ADD_TO_CART',
        description: 'Label text for add to cart icon',
        defaultMessage: 'Einpacken',
    },
});



// WEBPACK FOOTER //
// ./src/components/patterngalleries/PatternGalleryAppBar.js